<template>
    <div class="post-block">
        <router-link class="image-container" :to="postLink">
            <wp-image v-if="thumbnail"
                      :image="thumbnail"
                      size-hd="blog-thumbnail-hd"
                      class="thumbnail" />
            <div v-else class="post-missing-image-block">
                <span>Blog Post</span>
            </div>
            <div class="overlay">
                <p class="text">
                    Read Post
                </p>
            </div>
        </router-link>
        <div class="content-container">
            <p class="title">
                {{ title }}
            </p>
            <p class="date">
                {{ getDate }} {{ categoryList }}
            </p>
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs'

    export default {
        name: "PostBlock",
        props: {
            id: Number | String,
            date: String,
            thumbnail: Boolean | Array | Number,
            link: String,
            slug: String,
            title: String,
            index: Number,
            categories: Boolean | Array
        },
        computed: {
            postLink() {
                return `/blog/${this.slug}`
            },
            getDate() {
                return dayjs(this.date).format('MM.DD.YYYY');
            },
            categoryList() {
                if (!this.categories) return ''

                if (this.categories.length === 1) {
                    if (typeof this.categories[0] === 'object') {
                        return `| ${this.categories[0].name}`
                    }

                    return `| ${this.categories[0]}`
                }

                if (typeof this.categories[0] === 'object') {
                    const cats = this.categories.map((category) => {
                        return category.name
                    });
                    return `| ${cats.join(', ')}`
                }

                return `| ${this.categories.join(', ')}`
            }
        }
    }
</script>

<style lang="scss" scoped>

    .post-block {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 40px 20px;
        overflow: hidden;

        @media (max-width: 900px) {
            width: min-content;
        }

        @media (max-width: 630px) {
            width: 100%;
            padding: 20px 0;
        }
    }

    .image-container {
        position: relative;
        text-decoration: none;
        width: min-content;

        @media (max-width: 630px) {
            width: 100%;
        }

        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
            /* IE10+ styles */
            max-height: 240px;
            overflow: hidden;
        }

        .thumbnail {
            display: block;
            width: auto;
            max-height: 275px;

            &.loading {
                width: auto;
                height: 275px;
            }

            @media (max-width: 630px) {
                width: 100%;
                height: auto;
            }
        }

        .post-missing-image-block {
            width: 100%;
            max-height: 275px;
            background-color: $theme-blue;
            display: flex;
            justify-content: center;
            align-items: center;
            color: $white;

            span {
                font-size: 40px;
            }
        }

        .overlay {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            height: 100%;
            width: 100%;
            opacity: 0;
            transition: .5s ease;
            background-color: rgba($theme-blue, .60);
            cursor: pointer;

            .text {
                position: absolute;
                top: 50%;
                left: 50%;
                width: 100%;
                margin: 0;
                padding: 10px;
                max-width: 160px;
                font-size: 14px;
                text-transform: uppercase;
                letter-spacing: 3px;
                color: $theme-orange;
                font-weight: 600;
                border: 2px solid #E8B88B;
                transform: translate(-50%, -50%);
                -ms-transform: translate(-50%, -50%);
                text-align: center;

            }
        }

        &:hover {
            .overlay {
                opacity: 1;
            }
        }
    }

    .title {
        color: $theme-orange;
        margin-top: 25px;
        margin-bottom: 2px;
        font-size: 18px;
        font-weight: 600;
    }

    .date {
        color: $white;
        margin-top: 0;
        font-size: 15px;
        line-height: 25px;
    }

</style>